import { ThemeProvider } from "@mui/material/styles";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import I18nProvider from "./assets/i18n/I18nProvider";
import { pmTheme } from "./assets/js/Theme";
import { initGa } from "./resources/utils";
import { Routes } from "./router/Routes";
import "./style/index.scss";
import { ServicesProvider } from "./services/Provider";
import { buildServices } from "./services";
function App(props) {
  const { store, persistor, basename } = props;
  const services = buildServices();
  useEffect(() => {
    initGa();
  }, []);

  return (
    <ServicesProvider context={services}>
      <Provider store={store}>
        {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
        <PersistGate persistor={persistor}>
          {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
          <React.Suspense>
            {/* Override `basename` (e.g: `homepage` in `package.json`) */}
            <BrowserRouter basename={basename}>
              {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
              {/* <LastLocationProvider> */}
              {/* Provide Metronic theme overrides. */}
              <ThemeProvider theme={pmTheme}>
                {/* Provide `react-intl` context synchronized with Redux state.  */}
                <I18nProvider>
                  {/* Render routes with provided `Layout`. */}

                  <Routes />
                </I18nProvider>
              </ThemeProvider>
              {/* </LastLocationProvider> */}
            </BrowserRouter>
          </React.Suspense>
        </PersistGate>
      </Provider>
    </ServicesProvider>
  );
}

export default App;
